import React, { useState } from 'react';
import { orderService } from '../services/api';

const TrackOrder = () => {
  const [orderNumber, setOrderNumber] = useState('');
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleTrack = async (e) => {
    e.preventDefault();
    setError('');
    setOrder(null);

    if (!orderNumber.trim()) {
      setError('Please enter your order number');
      return;
    }

    try {
      setLoading(true);
      const res = await orderService.trackOrder(orderNumber.trim());
      if (res.success) {
        setOrder(res.order);
      } else {
        setError(res.message || 'Order not found');
      }
    } catch (err) {
      console.error(err);
      setError('Failed to track order. Please check your order number.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-16">
      <h1 className="text-4xl font-bold text-gray-800 mb-6 text-center">
        Track Your Order
      </h1>

      <form
        onSubmit={handleTrack}
        className="bg-white p-6 rounded-lg shadow-md mb-8"
      >
        {error && (
          <div className="mb-4 bg-red-100 text-red-700 px-4 py-2 rounded">
            {error}
          </div>
        )}
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Enter your order number
        </label>
        <div className="flex flex-col sm:flex-row gap-3">
          <input
            type="text"
            value={orderNumber}
            onChange={(e) => setOrderNumber(e.target.value)}
            placeholder="e.g. ORD-XXXXX"
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <button
            type="submit"
            disabled={loading}
            className="px-6 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg font-semibold hover:shadow-lg transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Tracking...' : 'Track Order'}
          </button>
        </div>
      </form>

      {order && (
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Order Information
          </h2>
          <div className="space-y-2 text-gray-700">
            <p>
              <span className="font-semibold">Order Number:</span>{' '}
              <span className="font-mono">{order.order_number}</span>
            </p>
            <p>
              <span className="font-semibold">Customer:</span>{' '}
              {order.customer_name}
            </p>
            <p>
              <span className="font-semibold">Phone:</span>{' '}
              {order.customer_phone}
            </p>
            <p>
              <span className="font-semibold">City:</span> {order.customer_city}
            </p>
            <p>
              <span className="font-semibold">Order Status:</span>{' '}
              <span className="capitalize">{order.order_status}</span>
            </p>
            <p>
              <span className="font-semibold">Payment Status:</span>{' '}
              <span className="capitalize">{order.payment_status}</span>
            </p>
            <p>
              <span className="font-semibold">Total Amount:</span>{' '}
              {order.total_amount} MAD
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrackOrder;
